import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SmartBtnModule } from '@y42/core/smart-btn';
import { GitHardResetButtonComponent } from './git-hard-reset-button.component';

@NgModule({
  imports: [CommonModule, MatButtonModule, FontAwesomeModule, SmartBtnModule],
  declarations: [GitHardResetButtonComponent],
  exports: [GitHardResetButtonComponent],
})
export class GitHardResetButtonModule {}
